
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { IAddShippingModel, IUserModel } from "@/api/types";
import { Message } from "element-ui";
import { FactoryLoadingPlan } from "@/model/FactoryLoadingPlan";
import ContainerTypeReleasedInfo from "@/views/components/ContainerTypeReleasedInfo.vue";
import {
  searchFactoryInvoices,
  getFactoryInvoiceProducts,
  getMoneyList,
  saveFactoryInvoiceProducts,
  updateCollectInvoiceState,
  updateRemark,
  downloadContract,
  editMoneyList, searchFactoryInvoicesNative,
} from "@/api/factory-invoices";
import FactoryLoadingPlanHqPackingListInfoTable from "@/views/components/FactoryLoadingPlanHqPackingListInfoTable.vue";
import TaxRefundDialog from "@/views/components/TaxRefundDialog.vue";
import { FactoryInvoices, LoadingAudit } from "@/model/factory-invoices";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson, uniqueArr } from "@/utils";
import {
  INTERNATIONAL_TRADE_TERMS,
  LADING_TYPE,
  PAYMENT_TYPE,
} from "@/constant";
import DeclarationDocumentTable, {
  LoadingPlanListTableRowData,
} from "@/views/components/DeclarationDocumentTable.vue";
import AuditTable from "@/views/components/AuditTable.vue";
import AdjustmentAmount from "./components/AdjustmentAmount.vue";
import ExtraTable from "@/views/components/ExtraTable.vue";
import { getTaxRefundInfo } from "@/api/booking-order";
import ContainerLoadingInfoComponent from "@/views/components/ContainerLoadingInfoComponent.vue";
import { ExtraMoneyList, TaxRefundInfo } from "@/model/FinancialBookingModels";
import { getFinancialConfiguration } from "@/api/configuration";
import { deepClone } from "@/utils/deepClone";
import { timeParser } from "@/filters";
import { add, subtract } from "@/utils/number";
import {queryDataSourceMode} from "@/api/invoice/index";

@Component({
  name: "FinancialBookingOrderManagement",
  components: {
    ContainerLoadingInfoComponent,
    DeclarationDocumentTable,
    AuditTable,
    ExtraTable,
    FactoryLoadingPlanHqPackingListInfoTable,
    ContainerTypeReleasedInfo,
    Pagination,
    TaxRefundDialog,
    AdjustmentAmount,
  },
  methods: {
    PAYMENT_TYPE,
    INTERNATIONAL_TRADE_TERMS,
    LADING_TYPE,
  },
})
export default class extends Vue {
  private dataMode = "";
  private tableKey = 0;
  private total = 0;
  private listLoading = false;
  private showFileList = false;
  private files: File[] = [];
  private textMap = {
    create: "新增报关合同",
    update: "编辑报关合同",
    addShippingOrder: "添加舱单",
    releaseContainerType: "分配柜型",
  };
  private JobPositionType = {
    seller: "seller",
    logisticsClerk: "logistics-clerk",
  };
  private sellerList: IUserModel[] = [];
  private logisticsClerkList: IUserModel[] = [];
  private shippingOrderList: IAddShippingModel[] = [];
  private payload = new FactoryLoadingPlan();
  private writeBookingOrderDialogVisible = false;
  private rules = {
    code: [{ required: true, message: "请输入报关合同号", trigger: "blur" }],
    customerId: [{ required: true, message: "请选择客户", trigger: "blur" }],
    shippingOrderId: [
      { required: true, message: "请选择订舱单", trigger: "blur" },
    ],
    currency: [{ required: true, message: "请选择结算货币", trigger: "blur" }],
  };
  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    bookingOrderCode: null,
    purchaseOrderNumber: null,
    factoryName: null,
    startDate: null,
    endDate: null,
    receiptState: null,
    sellerName: null,
  };
  private collectInvoiceReq = {
    collectInvoiceState: null,
    collectInvoiceDate: null,
  };
  private factoryInvoices: FactoryInvoices[] = [];
  private currentRow: FactoryInvoices = new FactoryInvoices();
  private currentExtra: ExtraMoneyList[] = [];
  private taxRefundInfo: TaxRefundInfo = new TaxRefundInfo();

  async created() {
    // this.initProcessStages();
    if (this.$route.params.bookingOrderCode) {
      this.listQuery.bookingOrderCode = this.$route.params.bookingOrderCode;
    }
    await this.getDataMode();
    await this.getList();
    await this.getFinancialConfiguration();
  }

  private async getDataMode() {
    const res = await queryDataSourceMode() as any;
    this.dataMode = res.name;
  }

  private getHiddenColumnsManager() {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes("updateAmountManager");
    }
  }

  private getHiddenColumnsUser() {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes("updateAmount");
    }
  }

  private handleFilter() {
    this.listQuery.pageNumber = 1;
    this.getList();
  }

  private downloadList() {
    const data = this.factoryInvoices.map((value) => {
      return {
        collectInvoice:
          value.collectInvoiceDate === null
            ? ""
            : timeParser(value.collectInvoiceDate) + value.collectInvoiceState,
        prerecordListCheckDate: timeParser(value.checkPrerecordListDate),
        otherDeductions:
          "贴标费用:" +
          value.deductions.labelingCharge +
          "索赔费用:" +
          value.deductions.claimCharge +
          "额外费用结算:" +
          value.deductions.deductionAndFilling +
          "备注:" +
          value.deductions.deductionAndFillingRemark +
          "其他费用:" +
          value.deductions.otherCharge,
        ...value,
      };
    });
    const headers = [
      "工厂名称",
      "负责销售员",
      "最终开票金额CNY",
      "发票收取日期",
      "报关合同号",
      "采购订单号",
      "报关品名",
      "结算数量",
      "开票单位",
      "预录单核对时间",
      "其他扣款",
      "报关金额",
      "FCR计算值",
      "备注",
    ];
    const fieldNames = [
      "factoryName",
      "seller",
      "finalInvoiceAmount",
      "collectInvoice",
      "bookingOrderCode",
      "purchaseOrderNumber",
      "factoryInvoiceProductsName",
      "settlementQuantity",
      "invoiceUnit",
      "prerecordListCheckDate",
      "otherDeductions",
      "declarationAmount",
      "fcr",
      "remark",
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `工厂开票-${new Date()}`
    );
  }

  private financialConfiguration: FinancialConfiguration =
    new FinancialConfiguration(null, null);

  private async getFinancialConfiguration() {
    const { exchangeRate, mer }: any = await getFinancialConfiguration();
    this.financialConfiguration = new FinancialConfiguration(exchangeRate, mer);
  }

  private async getList() {
    if (this.listQuery.startDate > this.listQuery.endDate) {
      Message({
        message: "结束日期必须大于起始日期",
        type: "error",
        duration: 2 * 1000,
      });
      return;
    }
    this.listLoading = true;
    const params = { ...this.listQuery };
    let content;
    let total;
    if (this.dataMode === "ACTUAL") {
      const res = await searchFactoryInvoices(params) as any;
      content = res.content;
      total = res.total;
    } else {
      const res = await searchFactoryInvoicesNative(params) as any;
      content = res.content;
      total = res.total;
    }
    content.map((item) => {
      item.factoryInvoiceProductsName = uniqueArr(
        item.factoryInvoiceProducts.map((val) => {
          return val.invoiceDescription;
        })
      ).toString();

      item.purchaseOrderNumber = item.factoryInvoiceProducts
        .map((val) => {
          return val.batch === null
            ? val.purchaseOrderNumber
            : val.purchaseOrderNumber + "(" + val.batch + ")";
        })
        .toString();

      item.invoiceUnit = uniqueArr(
        item.factoryInvoiceProducts.map((val) => {
          return val.settlementUnit;
        })
      ).toString();
    });
    this.factoryInvoices = content;
    this.total = total;
    this.listLoading = false;
  }

  private showRemark = false;

  private showRemarkDialog(row: FactoryInvoices) {
    this.currentRow = row;
    this.showRemark = true;
  }

  // 添加备注
  private async addRemark(currentRow: FactoryInvoices) {
    this.showRemark = false;
    await updateRemark(currentRow.id, currentRow.remark);
    currentRow.remark = null;
    await this.getList();
  }

  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "FACTORY_INVOICE", documentId: data.id },
    });
  }

  // 调整开票
  private showAudit = false;
  private currentRowIsEdit = false;

  private async showAuditDialog(row: FactoryInvoices, isEdit: boolean) {
    this.loadingPlans = [];
    this.loadingAudit = new LoadingAudit();
    this.loadingPlanFilter = new LoadingPlanFilter();
    this.currentRow = row;
    this.currentRowIsEdit = isEdit;
    const data: any = await getFactoryInvoiceProducts(row.id);
    this.loadingAudit = data;
    this.getTotalFCR();
    this.showAudit = true;
  }

  private getTotalQuantity() {
    let sum = 0;
    this.loadingAudit.factoryInvoiceProducts?.map((value) => {
      sum += value.quantity;
    });
    return sum;
  }

  //验审结算
  private async calculateTotal(name: string) {
    const info = deepClone(this.loadingAudit);
    info.factoryInvoiceProducts = (
      this.$refs.auditTableTable as Vue & { data_: [] }
    ).data_;
    let total = 0;
    info.factoryInvoiceProducts.forEach((item) => {
      total = item[name] + total;
    });
    this.loadingAudit[name] = Number(total.toFixed(4));
    this.getTotalFCR();
  }

  private totalFCR = 0;

  private getTotalFCR() {
    // 财税控制率=结算总金额/1.13/报关总金额
    const totalFCR =
      this.loadingAudit.totalAdjustAmount /
      1.13 /
      this.loadingAudit.totalDeclarationAmount;
    this.totalFCR = Number(totalFCR.toFixed(4));
  }

  // 保存调整
  private async handleSaveFactoryInvoiceProducts(confirm: boolean) {
    const info = deepClone(this.loadingAudit);
    info.factoryInvoiceProducts = (
      this.$refs.auditTableTable as Vue & { data_: [] }
    ).data_;
    const arr = uniqueArr(
      info.factoryInvoiceProducts.map((value) => value.settlementUnit)
    );
    // if (arr.length > 1) {
    //   Message.error({
    //     message: "结算的单位不一致，请调整",
    //     duration: 2000,
    //   });
    //   return;
    // }
    info.factoryInvoiceProducts.forEach((element) => {
      delete element.selectUnit;
    });
    const data: any = {
      confirm,
      totalAdjustAmount: info.totalAdjustAmount,
      totalDeclarationAmount: info.totalDeclarationAmount,
      factoryInvoiceProducts: info.factoryInvoiceProducts,
      settledHqPackingListIds: info.settledHqPackingListIds,
      totalFcr: this.totalFCR,
    };
    await saveFactoryInvoiceProducts(this.currentRow.id, data);
    this.showAudit = false;
    await this.getList();
  }

  // 额外费用结算
  private showExtra = false;
  private currentExtraIndex = 0;

  private async showExtraDialog() {
    let data: any = await getMoneyList(
      this.currentRow.id,
      this.loadingAudit.factoryName
    );
    data.map((data_item) => {
      let filling = data_item.moneyList.filter((item) => {
        return item.type === "FILLING";
      });
      let deduct = data_item.moneyList.filter((item) => {
        return item.type === "DEDUCT";
      });
      data_item.filling = filling.length ? filling[0] : null;
      data_item.deduct = deduct.length ? deduct[0] : null;
    });
    this.currentExtra = data;
    // this.currentExtraIndex = index;
    this.showExtra = true;
  }

  // 添加到结算
  private async addExtraMoney() {
    const selection = (
      this.$refs.extraTable as Vue & { selection: ExtraMoneyList[] }
    ).selection;
    const list = deepClone(selection);
    if (!list.length) {
      (
        this.$refs.auditTableTable as Vue & { getExtraInfo: Function }
      ).getExtraInfo({
        deductionAndFilling: null,
        deductionAndFillingRemark: null,
      });
    }
    const deductRemark = list.map((item) => {
      return item.deduct.remark;
    });
    const fillingRemark = list.map((item) => {
      return item.filling.remark;
    });
    const id = list.map((item) => {
      return item.hqPackingListId;
    });
    let deductionAndFilling = 0;
    list.map((item) => {
      item.total = subtract(item.settlementDeduct, item.settlementFilling, 2);
      deductionAndFilling = add(item.total, deductionAndFilling, 2);
    });
    const deductionAndFillingRemark = `${deductRemark.toString()},${fillingRemark.toString()}`;
    (
      this.$refs.auditTableTable as Vue & { getExtraInfo: Function }
    ).getExtraInfo({
      deductionAndFillingRemark,
      deductionAndFilling,
    });
    const data: { hqPackingListId; settlementFilling; settlementDeduct }[] =
      list;
    await editMoneyList(this.currentRow.id, {
      description: this.currentRow.declarationDescription,
      settlementMoneyList: data,
    });
    this.loadingAudit.settledHqPackingListIds = id;
    this.showExtra = false;
  }

  // 查看退税资料
  private showTaxRefund = false;

  private async getTaxRefundDialog(id: string) {
    const data: any = await getTaxRefundInfo(id);
    this.taxRefundInfo = data;
  }

  private loadingPlanFilter: LoadingPlanFilter = new LoadingPlanFilter();
  private loadingPlans: LoadingPlanListTableRowData[] = [];
  // 已选中的验审
  private loadingAudit: LoadingAudit = new LoadingAudit();

  private async handleEditCollectInvoiceState(row: FactoryInvoices) {
    if (!this.collectInvoiceReq.collectInvoiceState) {
      Message.error({ message: "请选择结算方式", duration: 2000 });
      return;
    }
    if (!this.collectInvoiceReq.collectInvoiceDate) {
      Message.error({ message: "请选择结算日期", duration: 2000 });
      return;
    }
    await updateCollectInvoiceState(
      row.id,
      this.collectInvoiceReq.collectInvoiceState,
      this.collectInvoiceReq.collectInvoiceDate
    );
    row.isEditCollectionStatePopoverVisible = false;
    this.collectInvoiceReq.collectInvoiceState = null;
    this.collectInvoiceReq.collectInvoiceDate = null;
    await this.getList();
  }

  private async downloadContract(row: FactoryInvoices) {
    await downloadContract(row.id);
  }

  // 导出excel
  private exportExcel() {
    const data = this.factoryInvoices.map((value) => {
      return {
        ...value,
      };
    });
    const headers = [
      "报关合同号",
      "截单日期",
      "申报日期",
      "货代",
      "订舱号",
      "客户收款时间",
      "报关状态",
      "客户简称",
      "使用IV金额",
      "结算货币",
      "处理阶段",
    ];
    const fieldNames = [
      "code",
      "customerAbbr",
      "createdAt",
      "isTransshipDelivery",
      "isLoadingInOneOrMorePlaces",
      "stateDesc",
      "shippingOrderCode",
      "",
      "",
      "remark",
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `报关合同（销售）-${new Date()}`
    );
  }
}

class FinancialConfiguration {
  exchangeRate: string;
  mer: string;

  constructor(exchangeRate: string, mer: string) {
    this.exchangeRate = exchangeRate;
    this.mer = mer;
  }
}

class DeclarationCharge {
  id: string;
  bookingOrderId: string;
  freight: string;
  insurance: string;
  extras: string;
}

// 工厂产品信息
class PurchaseOrderProductInfos {
  declarationProductAuditChargeId: string;
  invoiceDescription: string;
  purchaseOrderNumber: string;
  productNumberPcs: number;
  settlementUnit: string;
  unitPrice: number;
  labelingCharge: number;
  claimCharge: number;
  otherCharge: number;
  settlementUnitPrice: number;
  totalSettlementAmount: number;
  totalDeclarationAmount: number;
  deductionAndFilling: number;
  deductionAndFillingRemark: string;
}

class LoadingPlanFilter {
  code: string;
  category: string;
  factoryName: string;
}

export class LoadingPlanType {
  name: string;
  desc: string;
}
